import React from 'react';
import './BeachInfoPanel.css';

// Helper function to calculate polygon area using Shoelace formula
const calculatePolygonArea = (coordinates) => {
  if (!coordinates || coordinates.length < 3) return 0;
  
  let area = 0;
  const n = coordinates.length;
  
  for (let i = 0; i < n; i++) {
    const j = (i + 1) % n;
    area += coordinates[i][0] * coordinates[j][1];
    area -= coordinates[j][0] * coordinates[i][1];
  }
  
  // Convert to square kilometers (approximate)
  // 1 degree ≈ 111 km, so 1 square degree ≈ 12,321 km²
  return Math.abs(area) / 2 * 12321;
};

const BeachInfoPanel = ({ beachData, onClose }) => {
  if (!beachData) return null;

  const { beach, devices = [] } = beachData; // Default devices to empty array
  
  // Calculate beach area if coordinates are available
  let beachArea = null;
  if (beach.coordinates && beach.coordinates.length > 2) {
    beachArea = calculatePolygonArea(beach.coordinates);
  }

  return (
    <div className="beach-info-panel">
      <div className="beach-panel-header">
        <h3 className="beach-name">{beach.name}</h3>
        <button className="close-button" onClick={onClose}>
          ×
        </button>
      </div>
      
      <div className="beach-panel-body">
        {/* Beach Area Information */}
        {beachArea && (
          <div className="beach-area">
            <strong>Beach Area: {beachArea.toFixed(2)} km²</strong>
          </div>
        )}
        
        <div className="vehicles-count">
          <strong>Vehicles inside this area: {devices.length}</strong>
        </div>
        
        {devices.length > 0 ? (
          <div className="vehicles-list">
            {devices.map((device, index) => (
              <div key={device.device_id} className="vehicle-item">
                <div className="vehicle-name">
                  {device.displayName || device.name}
                </div>
                <div className="vehicle-details">
                  {device.device_type} • {device.device_id}
                </div>
                <div className="vehicle-battery">
                  Battery: {device.battery_level ? `${device.battery_level}%` : 'N/A'}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="no-vehicles">
            No vehicles currently in this area
          </div>
        )}
      </div>
    </div>
  );
};

export default BeachInfoPanel;
